export const SCREEN_SIZES = {
    mobile: [0, 850],
    tablet: [850, 1024],
    desktop: [1024, 1000000],
};
